import { Typography } from '@material-ui/core';
import { navigate } from '@reach/router'
import { Button, Cards } from 'ams-ui-reactkit';
import React, { useEffect, useState } from 'react'
import { TitleBlock } from '../../../atoms'
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import './ExtraOrdinary.scss'
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from './../../../context';
import { getSignatureByIndex } from "./../../../common/GlobalUtils"
import useSiganture from "../DigitalSignature/useSiganture";
import useCommon from "../common/useCommon"
import { getCustomerId, getDailysheetId } from '../../../utils/Utils';
import DynamicHtml from "../../../molecules/DynamicHtml"
import { AddSignatureBlock } from '../../../organisms';
import { actionTypeConstants } from '../../../utils';
const ExtraOrdinary: React.FC<TemplateProps> = (props: any) => {

    const { templateProps } = props;
    const signatures: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    const signByInd = getSignatureByIndex(signatures?.list, 2);

    const AgreeCheck: any = signatures?.extraOrdinary?.agreeCheck;
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);

    const [enableCheckbox, SetEnableCheckBox] = useState(AgreeCheck || false)
    const [enableButton, setEnableButton] = useState(false);

    let signUrl = signatures?.list?.find((s: any) => s.sequence === 1);
    const sign = signUrl?.getUrl || ""

    const { uploadSignature } = useSiganture();
    const { updateBolStatus } = useCommon();

    const handleSubmit = async () => {
        if (signByInd && !signByInd?.getUrl && signByInd?.putUrl) {
            uploadSignature(sign, signByInd)
        }
        updateBolStatus(getCustomerId(), getDailysheetId(), "ACCEPTED")
        navigate(templateProps?.nextScreen || '/')
    }


    useEffect(() => {
        (enableCheckbox) ? setEnableButton(true) : setEnableButton(false);
    }, [enableCheckbox])

    const handleSignClick = () => {
        SetEnableCheckBox(!enableCheckbox)
        dispatch({
            type: actionTypeConstants.EXTRA_ORDINARY_ACCEPT_SIGN,
            payload: {
                status: !enableCheckbox
            }
        })
    }

    return (
        <div className="baseContainerBlock">
            <Cards variant='default'>
                <div className="card-block-main">
                    {templateProps.title && <TitleBlock title={templateProps.title} />}
                    <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} align="left" className="fw-400 color-grey">
                        <DynamicHtml content={templateProps.subtitle || ""} />
                    </Typography>
                    <div className="mt-16">
                        <AddSignatureBlock signature={sign} enable={enableCheckbox} onClick={handleSignClick} />
                    </div>
                </div>
            </Cards>

            <div className="staticFixedButton">
                <Button
                    text={templateProps?.button}
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    size="large"
                    disabled={!enableButton}
                />
            </div>
        </div>
    )
}

export default ExtraOrdinary
